import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getRangeStringFromId } from "commons/src/NuDateUtils";

import { AnalysisView } from "./AnalysisView";
import { getSelectedAccountNum } from "../../helpers/NavigationHelpers";
import { fetchPPForClient } from "../../components/DataOperations";

function AnalysisViewContainerComponent({
    match,
    clientId,
    filteredAnalysis,
    selectedAccounts,
    history
}) {
    useEffect(() => {
        fetchMissingData(clientId, filteredAnalysis, match.params.rangeId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match]);

    const fetchMissingData = (clientId, analysis, rangeId) => {
        if (!analysis) {
            fetchPPForClient(clientId, rangeId);
        }
    };

    const accountNum = getSelectedAccountNum(match.params.accountNum, selectedAccounts);

    return (
        <AnalysisView
            account={accountNum}
            clientId={clientId}
            filteredAnalysis={filteredAnalysis}
            history={history}
            rangeId={match.params.rangeId}
            selectedAccounts={selectedAccounts}
        />
    );
}

AnalysisViewContainerComponent.propTypes = {
    clientId: PropTypes.number,
    filteredAnalysis: PropTypes.object,
    history: PropTypes.shape({
        goBack: PropTypes.func
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            accountNum: PropTypes.string,
            rangeId: PropTypes.string
        })
    }),
    selectedAccounts: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    const analysis = state.analysis || {};
    return {
        clientId: state.user.currentUser.clientId,
        filteredAnalysis: analysis[getRangeStringFromId(ownProps.match.params.rangeId)],
        selectedAccounts: state.accounts || {}
    };
};

export const AnalysisViewContainer = connect(mapStateToProps)(AnalysisViewContainerComponent);
